import { render, staticRenderFns } from "./Gpu.vue?vue&type=template&id=0812b456&"
import script from "./Gpu.vue?vue&type=script&lang=js&"
export * from "./Gpu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports